var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49967 0.746094C2.75967 0.746094 2.16634 1.34609 2.16634 2.07943V9.41276H3.49967V10.0794C3.49967 10.4461 3.79967 10.7461 4.16634 10.7461H4.83301C5.19967 10.7461 5.49967 10.4461 5.49967 10.0794V9.41276H9.49967V10.0794C9.49967 10.4461 9.79967 10.7461 10.1663 10.7461H10.833C11.1997 10.7461 11.4997 10.4461 11.4997 10.0794V9.41276H12.833V2.07943C12.833 1.34609 12.2397 0.746094 11.4997 0.746094H3.49967ZM7.49967 3.41276V2.07943H11.4997V3.41276H7.49967ZM7.49967 4.74609H11.4997V6.07943H7.49967V4.74609ZM4.83301 2.07943V4.74609H6.16634L4.16634 8.74609V6.07943H2.83301L4.83301 2.07943ZM14.1663 12.0794V13.4128H0.833008V12.0794H14.1663Z",
    fill: "#163C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantasIcon);
export default __webpack_public_path__ + "static/media/PlantasIcon.e1dfd1bef165a8b18afa6f0f23247505.svg";
export { ForwardRef as ReactComponent };